import Validatable from '@/validator/Validatable';

export const AttachableFees = ['CAMPAIGN', 'LINEITEM', 'PACKAGE', 'PACKAGE_GROUP', 'PLAN'] as const;
export type AttachableFeeType = (typeof AttachableFees)[number];

interface IAttachableFeeAPI {
  attachable_fee_category_id: number;
  organization_id: number;
  fee_category_id: number;
  fee_category?: { name: string; payer: string };
  entity_type: AttachableFeeType;
  archived: boolean;
}

export default class AttachableFee extends Validatable {
  constructor(
    public attachableFeeCategoryID: number,
    public organizationID: number,
    public feeCategoryID: number,
    public entityType: AttachableFeeType,
    public archived: boolean,
    public feeCategoryName?: string,
    public feeCategoryPayer?: string,
  ) {
    super();
  }

  toApi(): IAttachableFeeAPI {
    return {
      attachable_fee_category_id: this.attachableFeeCategoryID,
      organization_id: this.organizationID,
      fee_category_id: this.feeCategoryID,
      entity_type: this.entityType,
      archived: this.archived,
    };
  }

  static fromApi(object: IAttachableFeeAPI) {
    return new AttachableFee(
      object.attachable_fee_category_id,
      object.organization_id,
      object.fee_category_id,
      object.entity_type,
      object.archived,
      object.fee_category?.name,
      object.fee_category?.payer,
    );
  }
}
